import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 4}px 28px 0;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 32}px;
  font-weight: 700;
  color: ${({ theme }) => theme.THEME.neonBlue};
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  font-family: "Sora", sans-serif;

  svg {
    color: ${({ theme }) => theme.THEME.neonPink};
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
  }
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  color: ${({ theme }) => theme.THEME.white};
  line-height: 1.5;
  font-family: "Inter", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
